
/**
 * Used in interactionModels that implement inBB()
 * @author Ed Pataky
 * @enum {number} SelectionAccuracy
 */
var SelectionAccuracy = {
    LINES_HIGH: 30,
    LINES_MED: 15,
    LINES_LOW: 5,
    CIRCULAR_HIGH: 1,
    CIRCULAR_MED: 5,
    CIRCULAR_LOW: 10
};

module.exports = SelectionAccuracy;
